import { Component, Input } from '@angular/core';
import { ActivityMetricsV2MetricAuditRow, ActivityMetricsV2MetricContributorRow, ActivityMetricsV2MetricDefinition, ActivityMetricsV2MetricEligibilityRow, ActivityMetricsV2MetricResult, ActivityMetricsV2SourceCount } from '../../../../shared/models/activity-metrics-v2.model';

@Component({
  selector: 'app-agent-performance-activity-metrics-selected-metric-audit-widget',
  templateUrl: './agent-performance-activity-metrics-selected-metric-audit-widget.component.html',
  styleUrls: ['./agent-performance-activity-metrics-selected-metric-audit-widget.component.scss']
})
export class AgentPerformanceActivityMetricsSelectedMetricAuditWidgetComponent {
  @Input() metricResult: ActivityMetricsV2MetricResult | undefined;
  @Input() metricDefinition: ActivityMetricsV2MetricDefinition | undefined;
  @Input() metricAudit: ActivityMetricsV2MetricAuditRow | undefined;
  @Input() metricEligibility: ActivityMetricsV2MetricEligibilityRow | undefined;
  @Input() metricContributors: ActivityMetricsV2MetricContributorRow[] = [];
  @Input() sourceCounts: ActivityMetricsV2SourceCount[] = [];
  @Input() widget_title = 'Selected Metric Audit';
}
